import { render, staticRenderFns } from "./BlackGoldHero.vue?vue&type=template&id=2db207f8"
import script from "./BlackGoldHero.vue?vue&type=script&lang=js"
export * from "./BlackGoldHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports